<template>
  <div class="surewrap dialog-con"><!-- v-show="ApplyInfo.isShow"-->
    <div class="dialog-con-bg"></div>
    <div class="surepop dialog-warp">
        <div class="surecon font-MT text-333 f-tac">
          <slot name="surecon"></slot>
        </div>
        <div class="optionbox mt24">
          <slot name='optionbox'></slot>
        </div>
    </div>
    <div class="dialog-close" @click="closelogin()">
      <img src="../../assets/login/ic_close.png"/>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closelogin () {
      this.$emit('closesure', false)
    }
  }
};
</script>

<style lang="stylus" scoped>
.surewrap
    .surepop
        width 629px
        height 501px
        background url("../../assets/del-bg.png") no-repeat
        background-size 629px 501px
        .surecon
            width 448px
            margin auto
            font-size 12px
            font-weight 400
            line-height 26px
            margin-top 280px
        .optionbox
          width 448px
          position absolute
          bottom 70px
          left 50%
          margin-left -224px
</style>
